'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.closeInitialMessageBubble = undefined;

var _toggleInitialMessageBubble = require('./toggleInitialMessageBubble');

var _handleClosedWelcomeMessage = require('../../post-message/actions/handleClosedWelcomeMessage');

var _trackUserInteraction = require('../../actions/trackUserInteraction');

var closeInitialMessageBubble = exports.closeInitialMessageBubble = function closeInitialMessageBubble() {
  return function (dispatch) {
    dispatch((0, _handleClosedWelcomeMessage.handleClosedWelcomeMessage)());
    dispatch((0, _toggleInitialMessageBubble.toggleInitialMessageBubble)(false));
    dispatch((0, _trackUserInteraction.trackUserInteraction)());
  };
};